/* Product card colors (2026-10-25, Free People style). Styles: assets/rv-collection.css.
   Every color is in one sideways-scrolling row (snippets/product-item-swatches.liquid). When the colors
   don't fit, this shows a > at the right end and, once the row is scrolled, a < at the left; the row is
   sized to a whole number of colors so no color is ever cut in half, and each click moves it a "page"
   of colors (keeping one in view). The clicked color gets a ring and slides fully into view. The photo
   swap on a color click stays the existing handler in layout/theme.liquid. Cards added later (filters,
   Top Picks, search, You May Also Like) and card width changes (View 3/4/6, rotating a phone) are
   picked up. */
(function () {
  'use strict';

  var LIST = '.product-swatches-options__list';
  var SWATCH = '.product-swatches-options__item--swatch';
  var PAD = 3;   // list padding that makes room for the selected ring (rv-collection.css)
  var BTN = 18;  // a < or > button (16px) plus the 2px gap next to it

  function parts(scroller) {
    var list = scroller.querySelector(LIST);
    var swatches = list ? list.querySelectorAll(SWATCH) : [];
    var step = 0;
    var gap = 0;
    if (swatches.length > 1) {
      step = swatches[1].offsetLeft - swatches[0].offsetLeft;
      gap = step - swatches[0].offsetWidth;
    }
    return {
      list: list,
      swatches: swatches,
      step: step,
      gap: gap,
      prev: scroller.querySelector('[data-rv-swatch-prev]'),
      next: scroller.querySelector('[data-rv-swatch-next]')
    };
  }

  function reset(p) {
    p.prev.hidden = true;
    p.next.hidden = true;
    p.list.style.removeProperty('width');
    p.list.style.removeProperty('flex');
  }

  function update(scroller) {
    var p = parts(scroller);
    if (!p.list || !p.prev || !p.next) return;
    if (p.swatches.length < 2 || p.step <= 0) return reset(p);

    var n = p.swatches.length;
    var full = scroller.clientWidth;
    if (!full || n * p.step - p.gap <= full) return reset(p);

    // How many whole colors fit next to the given number of buttons.
    function fit(buttons) {
      return Math.max(1, Math.floor((full - BTN * buttons + p.gap) / p.step));
    }
    // "At the end" is always judged with the > hidden (the widest row). Judging it with the > shown
    // made the two layouts disagree near the end: the > flickered on and off and the row jiggled.
    var scrolled = p.list.scrollLeft;
    var prevOn = scrolled > 1;
    var k = fit(prevOn ? 1 : 0);
    var nextOn = scrolled < (n - k) * p.step - 1;
    if (nextOn) k = fit((prevOn ? 1 : 0) + 1);

    p.prev.hidden = !prevOn;
    p.next.hidden = !nextOn;
    p.list.style.flex = '0 0 auto';
    p.list.style.width = (k * p.step - p.gap + 2 * PAD) + 'px';
  }

  function visibleCount(p) {
    return Math.max(1, Math.round((p.list.clientWidth - 2 * PAD + p.gap) / p.step));
  }

  function scrollToIndex(p, index) {
    var max = p.list.scrollWidth - p.list.clientWidth;
    p.list.scrollTo({ left: Math.max(0, Math.min(max, index * p.step)), behavior: 'smooth' });
  }

  function page(scroller, direction) {
    var p = parts(scroller);
    if (!p.step) return;
    var first = Math.round(p.list.scrollLeft / p.step);
    scrollToIndex(p, first + direction * Math.max(1, visibleCount(p) - 1));
    // The < / > appearing or disappearing changes the row's room mid-slide; if that leaves just one
    // color still hidden in the direction of travel, finish the trip to that end.
    clearTimeout(scroller.__rvSwatchSettle);
    scroller.__rvSwatchSettle = setTimeout(function () {
      var max = p.list.scrollWidth - p.list.clientWidth;
      var left = p.list.scrollLeft;
      if (direction > 0 && max - left > 1 && max - left <= p.step + 1) {
        p.list.scrollTo({ left: max, behavior: 'smooth' });
      } else if (direction < 0 && left > 1 && left <= p.step + 1) {
        p.list.scrollTo({ left: 0, behavior: 'smooth' });
      }
    }, 450);
  }

  var observer = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
    entries.forEach(function (entry) { update(entry.target); });
  }) : null;

  function setup(scroller) {
    if (scroller.__rvSwatchScroller) return update(scroller);
    var list = scroller.querySelector(LIST);
    if (!list) return;
    scroller.__rvSwatchScroller = true;
    list.addEventListener('scroll', function () {
      if (scroller.__rvSwatchFrame) return;
      scroller.__rvSwatchFrame = requestAnimationFrame(function () {
        scroller.__rvSwatchFrame = null;
        update(scroller);
      });
    }, { passive: true });
    if (observer) observer.observe(scroller);
    update(scroller);
  }

  function setupAll() {
    document.querySelectorAll('[data-rv-swatch-scroller]').forEach(setup);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-rv-swatch-prev], [data-rv-swatch-next]');
    if (button) {
      event.preventDefault();
      event.stopPropagation();
      page(button.closest('[data-rv-swatch-scroller]'), button.hasAttribute('data-rv-swatch-next') ? 1 : -1);
      return;
    }

    var swatch = event.target.closest && event.target.closest('[data-rv-swatch-scroller] ' + SWATCH);
    if (!swatch) return;
    var p = parts(swatch.closest('[data-rv-swatch-scroller]'));
    Array.prototype.forEach.call(p.swatches, function (el) { el.classList.toggle('rv-swatch-active', el === swatch); });
    if (!p.step) return;
    // A color cut off at either end slides fully into view.
    var index = Array.prototype.indexOf.call(p.swatches, swatch);
    var first = Math.round(p.list.scrollLeft / p.step);
    var k = visibleCount(p);
    if (index < first) scrollToIndex(p, index);
    else if (index > first + k - 1) scrollToIndex(p, index - k + 1);
  });

  var pending;
  function later() {
    clearTimeout(pending);
    pending = setTimeout(setupAll, 100);
  }

  function start() {
    setupAll();
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) return later();
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('load', setupAll);
  window.addEventListener('resize', later);
})();
